import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DropdownService } from 'src/app/metricas/service/dropdown-metricas.service';
import { MetricasService } from 'src/app/metricas/service/metricas.service';
import { environment } from 'src/environments/environment';
import { FiltroResponsavelSharedService } from './service/filtro-responsavel.service';

interface Responsavel {
  id: number;
  name: string;
  userLevelId?: number;
}

@Component({
  selector: 'app-filtro-responsavel',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './filtro-responsavel.component.html',
  styleUrls: ['./filtro-responsavel.component.scss'],
})
export class FiltroResponsavelComponent {
  private carregouResponsaveis = false;
  private subscriptions: any[] = [];
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  @Input() set responsavel(value: any[]) {
    this._responsavel = (value || [])
      .slice()
      .sort((a, b) =>
        a.name.localeCompare(b.name, 'pt-BR', { sensitivity: 'base' })
      );

    if (
      this._responsavel.length === 1 &&
      (this._responsavel[0].userLevelId === 2 ||
        this._responsavel[0].userLevelId === 3)
    ) {
      this.ocultarTodos = true;

      if (this.filtroResponsavel !== String(this._responsavel[0].id)) {
        this.filtroResponsavel = String(this._responsavel[0].id);
        this.filtroResponsavelChange.emit(this.filtroResponsavel);

        this.responsavelIdChange.emit(this._responsavel[0].id);
      } else {
      }
    } else {
      this.ocultarTodos = false;
    }
  }

  private _responsavel: Responsavel[] = [];
  @Input() filtroResponsavel: string = 'Todos';
  ocultarTodos: boolean = false;
  @Input() isMaster = false;
  @Output() filtroResponsavelChange = new EventEmitter<string>();
  @Output() responsavelIdChange = new EventEmitter<number>();
  @Output() responsavelLimpo = new EventEmitter<void>();
  @Output() atualizandoMetricasChange = new EventEmitter<boolean>();
  @Output() responsaveisChange = new EventEmitter<Responsavel[]>();

  mostrarResponsavel = false;

  constructor(
    private _metricasService: MetricasService,
    private dropdownService: DropdownService,
    private filtroResponsavelShared: FiltroResponsavelSharedService
  ) {}

  ngOnInit(): void {
   
    const dropdownSub = this.dropdownService
      .getActiveDropdown()
      .subscribe((active) => {
        if (active !== 'responsavel') {
          this.mostrarResponsavel = false;
        }
      });
    this.subscriptions.push(dropdownSub);

    const responsavelIdSub =
      this.filtroResponsavelShared.responsavelId$.subscribe((id) => {
        if (!this.isMaster) {
          if (this.ocultarTodos && this._responsavel.length === 1) {
            this.filtroResponsavel = String(this._responsavel[0].id);
            this.filtroResponsavelChange.emit(this.filtroResponsavel);

            this.responsavelIdChange.emit(this._responsavel[0].id);
          } else {
            this.filtroResponsavel = id === 'Todos' ? 'Todos' : String(id);
            this.filtroResponsavelChange.emit(this.filtroResponsavel);

            this.responsavelIdChange.emit(
              id === 'Todos' ? 0 : Number(this.filtroResponsavel)
            );
          }
        }
      });
    this.subscriptions.push(responsavelIdSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  toggleResponsavel() {
    const isOpening = !this.mostrarResponsavel;
    this.dropdownService.setActiveDropdown(isOpening ? 'responsavel' : null);
    this.mostrarResponsavel = isOpening;
  }

  get responsavel(): Responsavel[] {
    return this._responsavel;
  }

  limparResponsavel() {
    if (this.ocultarTodos && this._responsavel.length === 1) {
      this.filtroResponsavel = String(this._responsavel[0].id);
      this.filtroResponsavelChange.emit(this.filtroResponsavel);
      this.responsavelIdChange.emit(this._responsavel[0].id);
      this.mostrarResponsavel = false;
      return;
    }
    this.atualizandoMetricasChange.emit(true);
    this.filtroResponsavel = 'Todos';
    this.filtroResponsavelChange.emit(this.filtroResponsavel);
    this.mostrarResponsavel = false;

    this.responsavelLimpo.emit();

    if (this.isMaster) {
      this.filtroResponsavelShared.setResponsavelId('Todos');
    }

    this.atualizandoMetricasChange.emit(false);
  }

  onResponsavelChange(): void {
    this.atualizandoMetricasChange.emit(true);
    this.mostrarResponsavel = false;
    this.dropdownService.setActiveDropdown(null);

    let id;
    if (this.ocultarTodos && this._responsavel.length === 1) {
      id = this._responsavel[0].id;
      this.filtroResponsavel = String(id);
    } else {
      id =
        this.filtroResponsavel === 'Todos'
          ? 'Todos'
          : Number(this.filtroResponsavel);
    }

    this.filtroResponsavelChange.emit(this.filtroResponsavel);

    if (this.ocultarTodos && this._responsavel.length === 1) {
      this.responsavelIdChange.emit(this._responsavel[0].id);
    } else {
      this.responsavelIdChange.emit(id === 'Todos' ? 0 : id);
    }

    if (this.isMaster) {
      this.filtroResponsavelShared.setResponsavelId(id);
    }

    this.atualizandoMetricasChange.emit(false);
  }

  get nomeResponsavelSelecionado(): string {
    if (this.filtroResponsavel === 'Todos') {
      return 'Todos os responsáveis';
    }
    const responsavel = this.responsavel.find(
      (r) => r.id === Number(this.filtroResponsavel)
    );
    return responsavel ? responsavel.name : this.filtroResponsavel;
  }

  shouldShowClearButton(): boolean {
    return this.filtroResponsavel !== 'Todos';
  }
}

